import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_CL_other_formats_title]: 'Other formats',
}